var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Upload-/-Blue",
    fill: "#5286F7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5123893,14.8748935 C15.6480627,14.9427303 15.73009,15.1157341 15.7584711,15.393905 C15.7584711,15.7284694 15.4869405,16 15.1523761,16 L0.606095043,16 C0.271530579,16 0,15.7284694 0,15.393905 C0.00978016191,15.1076372 0.0993657494,14.9346334 0.268756762,14.8748935 C0.433372383,14.8168378 0.747850158,14.7878099 1.21219009,14.7878099 L14.546281,14.7878099 C15.0566511,14.7790146 15.3786872,14.8080425 15.5123893,14.8748935 Z M7.87923556,0 C8.00336383,0 8.12749209,0.0380142811 8.23238048,0.113422202 L8.30713866,0.176979753 L13.155899,5.0257401 C13.3922761,5.26211717 13.3922761,5.64638142 13.155899,5.88275849 C12.9457861,6.09287144 12.618824,6.11621732 12.3827446,5.95279614 L12.2988806,5.88275849 L8.485,2.069 L8.48533061,11.7573347 C8.48533061,12.0584427 8.26539084,12.3084933 7.97750539,12.3554923 L7.87923556,12.3634297 C7.5446711,12.3634297 7.27314052,12.0918992 7.27314052,11.7573347 L7.27314052,11.7573347 L7.273,2.069 L3.45837832,5.88275849 C3.22200125,6.11913556 2.83773699,6.11913556 2.60135993,5.88275849 C2.39124698,5.67264554 2.36790109,5.34568346 2.53132228,5.10960403 L2.60135993,5.0257401 L7.45012027,0.176979753 C7.5689149,0.0593973142 7.72407523,0 7.87923556,0 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.645da45c476251495204a234446b7435.svg";
export { ForwardRef as ReactComponent };